"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequirementInstanceNoteSchema = void 0;
const zod_1 = require("zod");
const RequirementInstanceResultOverrideStatus_1 = require("./RequirementInstanceResultOverrideStatus");
exports.RequirementInstanceNoteSchema = zod_1.z.object({
    id: zod_1.z.string(),
    user: zod_1.z.string().optional(),
    contents: zod_1.z.string().optional(),
    analysisResultId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
    statusOverride: RequirementInstanceResultOverrideStatus_1.RequirementInstanceResultOverrideStatusSchema.optional(),
});
//# sourceMappingURL=RequirementInstanceNote.js.map